import { Component, ViewChild } from '@angular/core';
import { Platform, Nav } from 'ionic-angular';
import { StatusBar } from '@ionic-native/status-bar';
import { SplashScreen } from '@ionic-native/splash-screen';



import { TitlePage } from '../pages/title/title';
import { SocketProvider } from '../providers/socket/socket';
import { RoomPage } from '../pages/room/room';
import { WaitPage } from '../pages/wait/wait';
import { SnapPage } from '../pages/snap/snap';
import { JudgePage } from '../pages/judge/judge';
import { ScorePage } from '../pages/score/score';
import { FinalPage } from '../pages/final/final';

@Component({
  templateUrl: 'app.html'
})
export class MyApp {
  @ViewChild(Nav) nav: Nav;
  
    rootPage:any = TitlePage;

  constructor(
    platform: Platform, 
    statusBar: StatusBar, 
    splashScreen: SplashScreen, 
    private socketProvider: SocketProvider,
    // private navCtrl: NavController
    ) {
    platform.ready().then(() => {
      // Okay, so the platform is ready and our plugins are available.
      // Here you can do any higher level native things you might need.
      statusBar.styleDefault();
      splashScreen.hide();
      this.socketProvider.setScaler(platform.width());
    });
    this.socketProvider.getStateSubject().subscribe(this.handleData.bind(this));
  }

  handleData(data) {
    console.log(data);
    if (data.connected === "ok"){
      console.log("connected");
    } else if (data.players){
      this.socketProvider.players = data.players;
      console.log(this.socketProvider.players);
    } else if (data.state === "lobby") {
      this.socketProvider.setRoomNumber(data.room);
      this.nav.setRoot(RoomPage, {
        roomId: data.room || this.socketProvider.roomNumber
      });
    } else if (data.state === "wait") {
      this.nav.setRoot(WaitPage);
    } else if (data.state === "snap") {
      this.nav.setRoot(SnapPage, {
        ...data
      });
    } else if (data.state === "judge") {
      this.nav.setRoot(JudgePage, {
        ...data
      });
    } else if (data.state === "results") {
      this.nav.setRoot(ScorePage, {
        ...data
      });
    } else if (data.state === "final") {
      this.nav.setRoot(FinalPage, {
        ...data
      });
    }
  }
  
}



// WEBPACK FOOTER //
// ./src/app/app.component.ts